<template>
  <div class="comp-college-card">
    <div class="image">
      <img @error="imgError" :src="data.ShowImage" :alt="data.Name" />
    </div>
    <div class="text">
      <h4>
        <a @click="handleGo">{{
          data.Name
        }}</a>
      </h4>
      <p>{{ data.Introduction }}</p>
    </div>
    <div class="link">
      <a @click="handleGo">进入网站</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "college-card",
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    handleGo() {
      window.open(this.data.PortalLink, '_blank')
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-college-card {
  width: 376px;
  height: 485px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(154, 168, 222, 0.4);
  border-radius: 8px;
  overflow: hidden;
  .image {
    width: 376px;
    height: 176px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text {
    padding: 32px 0 0 16px;
    h4 {
      font-size: 24px;
      font-weight: 500;
      text-align: center;
      height: 32px;
      &:hover {
        cursor: pointer;
      }
    }
    p {
      width: 312px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 22px;
      margin: 16px auto 0 auto;
      height: 130px;
      overflow: hidden;
    }
  }
  .link {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 24px;
    &:hover {
      cursor: pointer;
    }
    a {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: rgba(69, 80, 238, 1);
      border-radius: 20px;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
      &:hover {
        background: rgba(69, 80, 238, 0.5);
      }
    }
  }
  &:hover {
    box-shadow: 0px 4px 8px 0px rgba(154, 168, 222, 0.8);
  }
}
</style>
